// extracted by mini-css-extract-plugin
export default {"wrapper":"CurrentEnvironmentDisplay_wrapper__8R48B"};